var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 12.0002C24.0004 7.24267 21.2317 3.13192 17.2178 1.19092V22.8094C21.2317 20.8685 24.0004 16.7577 24.0004 12.0002Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0002C0 16.7577 2.76867 20.8685 6.78263 22.8095V1.19092C2.76867 3.13192 0 7.24266 0 12.0002Z",
    fill: "#6DA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86914 12C8.86914 13.7289 10.2707 15.1305 11.9996 15.1305C13.7285 15.1305 15.13 13.7289 15.13 12V10.9565H8.86914V12Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.174 9.91311H13.0436C13.0436 9.33683 12.5764 8.86963 12.0001 8.86963C11.4238 8.86963 10.9566 9.33683 10.9566 9.91311H7.82617C7.82617 10.4894 8.32816 10.9566 8.90439 10.9566H8.86966C8.86966 11.5329 9.33681 12.0001 9.91314 12.0001C9.91314 12.5764 10.3803 13.0436 10.9566 13.0436H13.0436C13.6199 13.0436 14.0871 12.5764 14.0871 12.0001C14.6634 12.0001 15.1306 11.5329 15.1306 10.9566H15.0958C15.6721 10.9566 16.174 10.4894 16.174 9.91311Z",
    fill: "#FF9811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMexico);
export default __webpack_public_path__ + "static/media/Flag-Mexico.08ca534238972bc8ad03050108b362a2.svg";
export { ForwardRef as ReactComponent };